import React from 'react';
import { Image, Icon } from 'semantic-ui-react';
import { NetworkTypes } from '../../../../constants/networkTypes.js';

const CenterPanel = (props) => {
  const getLoadingRows = () => {
    let loadingRows = '';

    if (!props.myRoles || props.myRoles.length == 0) {
      //if we are fetching org units, then render this placeholder
      loadingRows = [0, 1].map((o, i) => {
        //this allows us to return 2 divs without a wrapper
        return (
          <div key={i} className="row flexible row-hoverable row-loading border-bottom">
            <div className="ui seven wide column  left-column-fixed left-text column bold  color-gray color-gray-bg pdnull  pdtnull " />

            <div className=" ui two wide computer only two wide tablet only column">
              <div className="ui active inverted dimmer " data-show={o == 0}>
                <div className="ui text loader mrtl " />
              </div>
            </div>

            <div className="ui seven wide column   left-column-fixed left-text column bold  color-gray color-gray-bg pdnull  pdtnull " />
            <div className="ui active inverted dimmer ">
              <div className="ui text loader  show-on-small-ress mrts" data-show={o == 0} />
            </div>
          </div>
        );
      });
    }
    return loadingRows;
  };

  const getHeaderRowMarkup = () => {
    let disableClass = props.saveIntermediateClick ? ' disableCenterPanel disable' : '';
    const tableHeaderMarkup = (
      <div className={'row flexible filterRowBackGround mrts pdtnull pdbnull header-row' + disableClass}>
        {/* Column #1 header */}
        <span className="ui sixteen wide column  icon input color-white hand display-flex">
          <input
            className="color-white borderless color-primary-dark-hover-lighter-bg max-width pdxs search"
            type="text"
            onChange={props.handleSearchTerm}
            value={props.searchTerm}
            placeholder={APP.LANGUAGE.MyRoles.Filter}
            style={{ lineHeight: '1.4em' }}
          />
          <i className="filter  icon mrrml" />
        </span>
      </div>
    );
    return tableHeaderMarkup;
  };

  const rendermyRoleRows = (myRoles, gray) => {
    let iterator = myRoles;
    if (iterator) {
      return iterator.map((myRole, i) => {
        let personNetworkRoleId = myRole.personNetworkRoleId;
        let removedClassName = myRole.isDeleted == true ? ' deleteRow ' : '';

        let secondRow = '';
        let iconNetworkType = (
          <Image src={APP.IMAGES.OrgUnitsIcon.default} className="centerAlignNetworkTypeIcon" circular />
        );

        if (myRole.typeId === NetworkTypes.WaitingArea) {
          iconNetworkType = (
            <Image src={APP.IMAGES.WaitingAreaIcon.default} className="centerAlignNetworkTypeIcon" circular />
          );
        } else if (myRole.typeId === NetworkTypes.MeetingRoom) {
          iconNetworkType = (
            <Image src={APP.IMAGES.MeetingRoomIcon.default} className="centerAlignNetworkTypeIcon" circular />
          );
        } else if (myRole.typeId === NetworkTypes.GroupConsultation) {
          iconNetworkType = (
            <Image src={APP.IMAGES.GCWaitingAreaIcon.default} className="centerAlignNetworkTypeIcon" circular />
          );
        }

        return (
          <div
            className={'row flexible row-hoverable border-bottom whiteBackGround' + removedClassName}
            data-opaque={!!gray}
            key={personNetworkRoleId}
            data-show={
              (props.saveIntermediateClick == true && myRole.isDeleted == true) || !props.saveIntermediateClick
            }
          >
            <div className={'ui one wide computer only   left-text column centerAlignNetworkTypeIcon'}>
              {iconNetworkType}
            </div>
            <div className={'ui one wide  tablet mobile only left-text column centerAlignNetworkTypeIcon'}>
              {iconNetworkType}
            </div>

            {/* for computer only */}
            <div className={'ui seven wide computer only  left-text column centerAlignVertical wrap-link '}>
              {myRole.name}
              <br />{' '}
              <div
                className={'mobileSecondRow   text-size-ms ' + removedClassName}
                data-show={myRole.type != 'Organisational Unit'}
              >
                {myRole.organisationAbbreviatedName}
              </div>
            </div>
            <div className={'ui  seven wide  computer only  column centerAlignVertical   '}>{myRole.role}</div>

            {/* for tablet and mobile */}
            <div className={'ui thirteen wide tablet mobile only  left-text column centerAlignVertical  wrap-link '}>
              {myRole.name + (myRole.type != 'Organisational Unit' ? ` (${myRole.organisationAbbreviatedName})` : '')}
              <br /> <div className={'mobileSecondRow   text-size-ms ' + removedClassName}>{myRole.role}</div>
            </div>

            <div
              className={'ui one wide  centerAlignIcons '}
              onClick={() => {
                props.handleDeleteRole(personNetworkRoleId);
              }}
              data-show={!myRole.isDeleted}
            >
              <Icon name="trash" className="removeIcon " />
            </div>
            <div
              className={'ui one wide  centerAlignIcons'}
              onClick={() => {
                props.handleUndoDeleteRole(personNetworkRoleId);
              }}
              data-show={!!myRole.isDeleted}
            >
              <Icon name="undo" className="undoIcon" />
            </div>
          </div>
        );
      });
    }
  };

  let myRolesMatchingSearchTermMarkup = '';
  let myRolesNotMatchingSearchTermMarkup = '';

  if (props.myRoles && props.myRoles.length > 0) {
    const sortedmyRolesList = props.myRoles;
    let myRolesMatchingSearchTerm = sortedmyRolesList;
    let myRolesNotMatchingSearchTerm = [];
    const searchTerm = props.searchTerm;

    if (searchTerm && searchTerm.trim().length > 0) {
      // do the filtering
      const searchTermLowerCase = searchTerm.toLowerCase();
      myRolesMatchingSearchTerm = [];
      myRolesNotMatchingSearchTerm = [];

      sortedmyRolesList.forEach((myRole) => {
        if (
          myRole.name.toLowerCase().indexOf(searchTermLowerCase) > -1 ||
          myRole.organisationAbbreviatedName.toLowerCase().indexOf(searchTermLowerCase) > -1 ||
          myRole.role.toLowerCase().indexOf(searchTermLowerCase) > -1
        )
          myRolesMatchingSearchTerm.push(myRole);
        else {
          myRolesNotMatchingSearchTerm.push(myRole);
        }
      });
    }
    myRolesMatchingSearchTermMarkup = rendermyRoleRows(myRolesMatchingSearchTerm, false);
    myRolesNotMatchingSearchTermMarkup = rendermyRoleRows(myRolesNotMatchingSearchTerm, true);
  }
  return (
    <div className="my-roles-view-all text-size-mms ">
      <div className="ui sixteen column grid pdlm  pdrm">
        {getHeaderRowMarkup()}
        {getLoadingRows()}
        <div className="row flexible ui grid" id="my-roles-view-all-scroll-wrapper">
          {myRolesMatchingSearchTermMarkup}
          {myRolesNotMatchingSearchTermMarkup}
        </div>
      </div>
    </div>
  );
};

export default CenterPanel;
